module.exports = __webpack_public_path__ + "static/media/tech–competency-mapping.a9d06c8a.svg";